// dark and light theme variables

export const lightTheme = {

    body: "#FCF6F4",
    text: "#000000",
    fontFamily: "'Source Sans Pro', sans-serif",
    bodyRgba: "252, 246, 244",
    textRgba: "0,0,0",
}

export const DarkTheme = {

    body: "#000000",
    text: "#FCF6F4",
    fontFamily: "'Source Sans Pro', sans-serif",
    textRgba: "252, 246, 244",
    bodyRgba: "0,0,0",
}

export const MyTheme = {
    body: "#0D5669",
    text: "#DE708D",
    fontFamily: "'Source Sans Pro', sans-serif",
    textRgba: "248, 243, 146",
    bodyRgba: "#DE708D",
    backgraund: "#0D5669"
}
